import React, { Component } from 'react'
import { Router, Route, Switch } from 'react-router-dom'
import Loadable from 'react-loadable'
import appHistory from './core/history'
import { domains } from './services'
import Error from './ui/views/error'
import Layout from './ui/shared/layout'
import LayoutSimple from './ui/shared/layout-simple'
import LayoutLanding from './services/layout/LayoutLanding'
import Home from './ui/views/home'
import Login from './ui/views/login'
import Register from './ui/views/register'
import SearchResults from './services/search-results/SearchResults'
import ItemDetail from './services/item/ItemDetail'
import CharityDetail from './services/charity/CharityDetail'
import CharityOurAuctions from './services/charity/CharityOurAuctions'
import CharityContact from './services/charity/CharityContact'
import AuctionDetail from './services/auction/AuctionDetail'
import BidItem from './services/bid/BidItem'
import RegistrationSucess from './ui/views/registration-success'
import StripeConnectCallback from './services/stripe/ConnectCallback'
import RegisterCharityWizard from './services/register-charity/Wizard'
import AboutUs from './ui/views/about-us'
import Terms from './ui/views/terms'
import Contact from './ui/views/contact'
import PrivacyPolicy from './ui/views/privacy-policy'
import Help from './ui/views/help'
import Loading from './ui/views/loading'
import Landing from './ui/views/landing'
import VerifyEmail from './services/email-verification/VerifyEmail'
import VerifySuccess from './services/email-verification/VerifySuccess'
import VerifyFail from './services/email-verification/VerifyFail'
import ForgetPassword from './services/password-reset/ForgetPassword'
import ResetPassword from './services/password-reset/ResetPassword'

const LoadableMyCharity = Loadable({
  loader: () => import('./mycharity'),
  loading: Loading
})

const LoadableMyProfile = Loadable({
  loader: () => import('./myprofile'),
  loading: Loading
})

/* eslint-disable react/jsx-no-bind */
const RouteWithLayout = ({ layout, layoutTheme, component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      React.createElement(
        layout,
        { theme: layoutTheme, ...props },
        React.createElement(component, props)
      )
    }
  />
)
const SearchResultsItems = props => (
  <SearchResults {...props} domain={domains.ITEMS} />
)
const SearchResultsAuctions = props => (
  <SearchResults {...props} domain={domains.AUCTIONS} />
)
const SearchResultsCharities = props => (
  <SearchResults {...props} domain={domains.CHARITIES} />
)

class App extends Component {
  render() {
    return (
      <Router history={appHistory}>
        <Switch>
          <RouteWithLayout
            layout={LayoutLanding}
            layoutTheme='dark-theme'
            exact
            path='/'
            component={Landing}
          />
          <RouteWithLayout
            layout={Layout}
            layoutTheme='dark-theme'
            exact
            path='/explore'
            component={Home}
          />
          <RouteWithLayout
            layout={Layout}
            layoutTheme='dark-theme'
            exact
            path='/items/:id/bid'
            component={BidItem}
          />
          <RouteWithLayout
            layout={Layout}
            layoutTheme='light-theme'
            exact
            path='/items/:id'
            component={ItemDetail}
          />
          <RouteWithLayout
            layout={Layout}
            layoutTheme='dark-theme'
            exact
            path='/charities'
            component={SearchResultsCharities}
          />
          <RouteWithLayout
            layout={Layout}
            layoutTheme='light-theme'
            exact
            path='/charities/:id'
            component={CharityDetail}
          />
          <RouteWithLayout
            layout={Layout}
            layoutTheme='dark-theme'
            exact
            path='/charities/:id/auctions'
            component={CharityOurAuctions}
          />
          <RouteWithLayout
            layout={Layout}
            layoutTheme='dark-theme'
            exact
            path='/charities/:charityId/items'
            component={SearchResultsItems}
          />
          <RouteWithLayout
            layout={Layout}
            layoutTheme='light-theme'
            exact
            path='/charities/:id/contact'
            component={CharityContact}
          />
          <RouteWithLayout
            layout={Layout}
            layoutTheme='dark-theme'
            exact
            path='/auctions'
            component={SearchResultsAuctions}
          />
          <RouteWithLayout
            layout={Layout}
            layoutTheme='light-theme'
            exact
            path='/auctions/:id'
            component={AuctionDetail}
          />
          <RouteWithLayout
            layout={Layout}
            layoutTheme='dark-theme'
            exact
            path='/auctions/:auctionId/items'
            component={SearchResultsItems}
          />
          <RouteWithLayout
            layout={Layout}
            layoutTheme='dark-theme'
            exact
            path='/items'
            component={SearchResultsItems}
          />
          <RouteWithLayout
            layout={LayoutSimple}
            layoutTheme='gradient-theme'
            exact
            path='/login'
            component={Login}
          />
          <RouteWithLayout
            layout={LayoutSimple}
            layoutTheme='gradient-theme'
            exact
            path='/register'
            component={Register}
          />
          <RouteWithLayout
            path='/register-success'
            layout={Layout}
            layoutTheme='gradient-theme'
            component={RegistrationSucess}
            exact
          />
          <RouteWithLayout
            path='/register-charity'
            layout={Layout}
            component={RegisterCharityWizard}
            exact
          />
          <RouteWithLayout
            path='/stripe-redirect'
            layout={Layout}
            component={StripeConnectCallback}
            exact
          />
          <Route path='/mycharity' component={LoadableMyCharity} />
          <Route path='/myprofile' component={LoadableMyProfile} />
          <Route path='/checkout' component={LoadableMyProfile} />
          <RouteWithLayout
            path='/about-us'
            layout={Layout}
            layoutTheme='light-theme'
            component={AboutUs}
            exact
          />
          <RouteWithLayout
            path='/terms'
            layout={Layout}
            layoutTheme='light-theme'
            component={Terms}
            exact
          />
          <RouteWithLayout
            path='/contact'
            layout={Layout}
            layoutTheme='light-theme'
            component={Contact}
            exact
          />
          <RouteWithLayout
            path='/privacy-policy'
            layout={Layout}
            layoutTheme='light-theme'
            component={PrivacyPolicy}
            exact
          />
          <RouteWithLayout
            path='/help'
            layout={Layout}
            layoutTheme='light-theme'
            component={Help}
            exact
          />
          <RouteWithLayout
            layout={Layout}
            path='/verify/:token'
            component={VerifyEmail}
            exact
          />
          <RouteWithLayout
            layout={Layout}
            path='/verify-success'
            component={VerifySuccess}
            exact
          />
          <RouteWithLayout
            layout={Layout}
            path='/verify-failed'
            component={VerifyFail}
            exact
          />
          <RouteWithLayout
            layout={Layout}
            path='/forget-password'
            component={ForgetPassword}
            exact
          />
          <RouteWithLayout
            layout={Layout}
            path='/change-password'
            component={ForgetPassword}
            exact
          />
          <RouteWithLayout
            layout={Layout}
            path='/reset-password/:token'
            component={ResetPassword}
            exact
          />
          <RouteWithLayout
            layout={Layout}
            layoutTheme='light-theme'
            component={Error}
          />
        </Switch>
      </Router>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/app.js